import type { FadeAnimationStyle } from '@rio-cloud/rio-uikit/Fade';
import ChatView from '../features/chat/ChatView';
import { ChatNotBookedView } from '../features/chat/ChatNotBookedView';
import { ChatLoadingState } from '../features/chat/ChatLoadingState';
import { useSetupWindowMessages } from '../sendbird/hooks/useSetupWindowMessages';
import { useShowAdvertisementBadge } from '../hooks/useShowAdvertisementBadge';
import { useIsChatActivated } from '../features/chat/chatSlice';

export const AppContent = ({
    animationStyle,
    currentLocation,
}: {
    animationStyle: FadeAnimationStyle;
    currentLocation: string;
}) => {
    // don't use rtkQuery directly, as this leads to problems with re-rendering in chrome when the chat is not opened
    // instead save the response in redux state and use a selector here
    const isChatActivated = useIsChatActivated();

    useSetupWindowMessages();

    useShowAdvertisementBadge(isChatActivated);

    if (isChatActivated === undefined) {
        return <ChatLoadingState />;
    }

    if (!isChatActivated) {
        return <ChatNotBookedView />;
    }

    return <ChatView animationStyle={animationStyle} currentLocation={currentLocation} />;
};
